import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const CUSTOMER_TOKEN_KEY = "bicimone_customer_token";

const publicApi = axios.create({ baseURL: API });

publicApi.interceptors.request.use((config) => {
  const t = localStorage.getItem(CUSTOMER_TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function setCustomerToken(token) {
  if (token) localStorage.setItem(CUSTOMER_TOKEN_KEY, token);
  else localStorage.removeItem(CUSTOMER_TOKEN_KEY);
}

export default publicApi;
